import React, { Component } from "react";
import { Link } from "react-router-dom";
import MailchimpSignup from "./MailchimpSignUp";
import "../style/Home.css";
export class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animation: false
    };
  }
  componentDidMount() {
    this.setState({ animation: true });
  }
  render() {
    return (
      <div
        className={
          this.state.animation ? "animate-in home-container" : "home-container"
        }
      >
        <div className="home-card">
          {/* <div className="home-card-title">
            <img
              style={{ width: "100%" }}
              src="https://www.sjcnc.org/wp-content/uploads/2016/08/IMG_7128-1.jpg"
              alt="" 
            />
            <h1 style={{ marginTop: "2rem" }}>Hello, I'm Heath Morber!</h1>
          </div> */}
          <div className="home-card-body">
            <div className="about-heading">
              <h1>About englishmotets.com</h1>
            </div>
            <p>
              The summers are sleepy at St. John's Catholic Newman Center in
              Champaign, IL. We serve college students and when they take off
              for the summer, it gets REAL quiet.
            </p>
            <p>
              I always struggled to find simple, yet beautiful pieces to sing
              with only two people since I worked with just a cantor. I began to
              take two-part excerpts from Renaissance Mass Ordinaries (e.g. a
              Benedictus from a Lassus Mass was my first foray), re-set them
              with English Eucharistic texts, and used them as post-Communion
              meditations. I started to dig up motets to set, using literal, yet
              elegant singing translations.
            </p>
            <p>
              Years later, I have dozens of these settings for nearly every
              liturgical occasion and context, all available here at
              englishmotets.com.
            </p>
            <p>
              The project is directed mostly at Catholic musicians who want to
              expose their congregations to the beauty of Renaissance polyphony
              but also believe that the use of the vernacular may be a safe way
              to introduce this music to people in the pews who may balk at
              pieces in Latin. In addition, choir directors will find many
              pieces for small choirs, some of it easy and accessible for
              polyphonic neophytes, and others that will prove satisfying for
              advanced singers.
            </p>
            <p>
              It's my hope that non-Catholic churches and maybe some high school
              choir programs may benefit from this site, as well!
            </p>
            <p>
              The best part is that scores will be added each month; with
              thousands of sacred pieces in the polyphonic repertoire, there are
              no concerns that I'll run out of pieces to adapt!
            </p>
            <div className="about-heading">
              <h1>Layout</h1>
            </div>
            <p>
              Over 200 files have been uploaded, in various keys, voicings,
              liturgical seasons and parts of the Mass. You can search by title
              or use the dropdown menus to select keywords that will modify
              search results. We're striving to make the site as accessible as
              possible, so please let us know if something is less than
              intuitive!
            </p>
            <div className="about-heading">
              <h1>Subscription model</h1>
            </div>
            <p>
              Right now you can see a one-page preview of every piece on the
              site. It's the hope that once you see the wide selection, the
              beautiful engraving of the scores and the ease of use, you'll want
              to see and use the full scores!
            </p>
            <p>The subscription model could hardly be easier:</p>
            <ul className="about-list">
              <li>one-time payment</li>
              {/* <li>full access to all the scores... forever</li> */}
            </ul>
            <p>
              That's it. One payment and you and your church/school can take
              advantage of these scores until the Internet disappears.{" "}
            </p>
            <p>The pricing model we use looks like this:</p>
            <ul className="about-list">
              <li>
                The subscription model could hardly be easier. It's a one-time
                payment of $30
              </li>
              <li>Full access to all the scores... forever</li>
              <li>
                That's it. One payment and you and your church/school can take
                advantage of these scores until the Internet disappears.
              </li>
              {/* <li>Small church (1-2 services): $40</li>
              <li>Medium church (3-4 services): $60</li>
              <li>Large church (5-6 services): $80</li>
              <li>Schools: $50</li> */}
            </ul>
            <MailchimpSignup center />
          </div>
          <div className="home-card-cta">
            <a href="https://englishmotets.com" className="btn-home-card">
              Check out English Motets
            </a>
          </div>
          <p>
            Questions? Contact us <Link to="/contact">here</Link>
          </p>
          <h1 id="samples">Audio recordings</h1>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js